<template>
  <div>
    <div class="select-goods">
      <div class="btn-group">
        <!-- <div class="top-btn-danju">合约商品</div> -->
        <div
          style="width: 100%;display:flex;align-items: center;justify-content: space-between;"
        >
          <div style="font-size:12px;font-weight:700">
            合同号：{{ contract_no }}
          </div>
          <div>
            <el-button @click="importExcel" size="mini">导入合同商品</el-button>
            <el-button @click="addLine" size="mini">新增一行</el-button>
            <el-button type="danger" @click="deleteLine" size="mini"
              >删除选中</el-button
            >
          </div>
        </div>
      </div>
      <ve-table
        :max-height="change_box ? 300 : 450"
        :min-height="300"
        rowKeyFieldName="rowKey"
        :fixed-header="true"
        :columns="columns"
        :table-data="contract_Goods"
        :editOption="editOption"
        :rowStyleOption="rowStyleOption"
        :checkbox-option="checkboxOption"
        :style="change_box ? 'heigt:300px' : 'height:450px'"
        border-y
        border-x
        :border-around="true"
      />
      <div style="margin-top:10px" v-if="change_box">
        <el-scrollbar
          wrapStyle="overflow-x:hidden;"
          style="height:150px;background-color: #d8fbff5e;"
        >
          <div style="width:100%;height:auto;padding: 10px;">
            修改记录：
          </div>
        </el-scrollbar>
      </div>
      <!-- <div v-show="showEmpty" class="empty-data">暂无数据</div> -->
      <div>
        <div
          class="btn-group"
          size="mini"
          style=" justify-content: center;margin-top: 10px;"
        >
          <div v-if="!btn_modify">
            <el-button type="primary" @click="submitCollection(0)"
              >提交合同</el-button
            >
            <!-- <el-button type="primary" @click="submitCollection(1)"
              >提交合同并提交商品</el-button
            > -->
          </div>
          <div v-else>
            <el-button type="primary" @click="submitCollection(2)"
              >保存修改</el-button
            >
          </div>
        </div>
      </div>
      <div></div>
    </div>
    <excel
      ref="excel"
      @update-import="getTableData"
      @cover-import="CoverTableData"
      >追加并导入</excel
    >
  </div>
</template>

<script>
import excel from "@/components/excel.vue";
import { deleteTabRepeat } from "@/js/public";
import {
  baseGoodsQuery,
  GenerateContractItems
} from "@/api/baseinfo";

export default {
  components: { excel },
  name: "contractgoods",
  props: {
    btn_modify: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      contract_no: "",
      rowkey: -1,
      showEmpty: true,
      //表中的商品
      contract_Goods: [],
      //选中列表
      check_goods: [],
      //商品表格
      columns: [
        {
          field: "",
          key: "c",
          // type=checkbox
          type: "checkbox",
          title: "",
          width: "3%",
          align: "center"
        },
        {
          field: "",
          key: "a",
          title: "行号",
          width: "4%",
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return ++rowIndex;
          }
        },
        {
          field: "barcode",
          key: "barcode",
          title: "商品条码",
          align: "left",
          width: "6%",
          edit: true
        },
        {
          field: "item_name",
          key: "item_name",
          title: "商品名称",
          align: "left",
          width: "9%",
          edit: true,
          ellipsis: {
            showTitle: true
          }
        },
        {
          field: "price",
          key: "price",
          title: "合约价",
          align: "left",
          width: "6%",
          edit: true
        },
        {
          field: "advise_price",
          key: "advise_price",
          title: "建议售价",
          align: "left",
          width: "6%",
          edit: true
        }
      ],
      // 高亮显示
      rowStyleOption: {
        clickHighlight: false
      },
      contract_id: "",
      //合同列表
      contract_options: [
        {
          label: "",
          value: ""
        }
      ],
      // 修改的钩子
      editOption: {

        // cell value change
        afterCellValueChange: ({ row, column, changeValue }) => {
          var that = this;
          if (
            row.rowKey == this.rowkey &&
            row.barcode != "" &&
            row.price != ""
          ) {
            console.log("修改之后cellValueChange row::", row);
            that.addLine();
          }
        },
        beforeCellValueChange: ({ row, column, changeValue }) => {
          /* console.log("修改之前cellValueChange row::", row);
          console.log("修改之前cellValueChange column::", column);
          console.log("修改之前cellValueChange changeValue::", changeValue); */
        }
      },
      //多选框事件
      checkboxOption: {
        // 行选择改变事件
        selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
          let _index = -1;
          _index = this.check_goods.indexOf(row.barcode);
          if (isSelected) {
            this.check_goods.push(row.barcode);
          }
          if (isSelected == false && _index > -1) {
            this.check_goods.splice(_index, 1);
          }
        },
        // 全选改变事件
        selectedAllChange: ({ isSelected, selectedRowKeys }) => {
          this.check_goods = [];
          if (isSelected) {
            this.contract_Goods.forEach((item, index, arr) => {
              this.check_goods.push(item.barcode);
            });
          } else {
            this.check_goods = [];
          }
        }
      },
      change_box: false
    };
  },
  inject: ["QueryContract"],
  async mounted() {
   /*  setTimeout(()=>{
      this.settime();
    })
    this.$nextTick(()=>{
      this.nexTick();
    }) */
    const res = await this.QueryContract();
    console.log("creategoods返回值：", res);
  },
  methods: {
    

    setcontractNo(e){
          this.contract_no = e;
        },
    deleteLine() {
      this.contract_Goods = deleteTabRepeat(
        this.check_goods,
        this.contract_Goods,
        "barcode"
      );
      this.assignmentRowKey();
    },
    importExcel() {
      this.$refs.excel.showModel();
    },
    // 更新按钮子组件返回值
    async getTableData(val) {
      this.tableDataShow = false;
      var mtable = [];
      var detable = [];
      var newtab = [];
      var newnewtab = [];
      // var
      //循环所有表格上传的数组
      for (var i = 0; i < val.length; i++) {
        //查找每一个数组元素的barcode，看看在tableDate是否已经存在
        var _index = this.contract_Goods.findIndex(
          x => x.barcode == val[i].barcode
        );
        //如果已存在 将表数据覆盖为导入值
        if (_index > -1) {
          mtable.push({
            barcode: val[i].barcode,
            item_name: this.contract_Goods[_index].item_name,
            price: val[i].price,
            advise_price: this.contract_Goods[_index].advise_price
          });
          //保存重复的值，等待删除操作
          detable.push(this.contract_Goods[i].barcode);
        } else {
          //如果tableData中不存在查询基础库
          const res = await baseGoodsQuery(val[i].barcode);
          console.log("res:--------------------------------", res);
          //如果基础库中不存在
          if (res == [] || res == false) {
            newnewtab.push({
              barcode: val[i].barcode,
              item_name: val[i].item_name ? val[i].item_name : "",
              price: val[i].price,
              advise_price: val[i].advise_price ? val[i].advise_price : 0
            });
            //如果基础库中存在 存在一条或者多条，先考虑一条的情况，多条先不考虑
          } else if (res.length >= 1 && res != false) {
            newtab.push({
              barcode: val[i].barcode,
              item_name: res[0].item_name ? res[0].item_name : "",
              price: val[i].price,
              advise_price: res[0].advise_price ? res[0].advise_price : 0
            });
          }
          // val[i].flow_no = this.contract_Goods.length;
          // this.contract_Goods.push(val[i]);
        }
      }
      //去除掉原来表中相同的商品
      this.contract_Goods = deleteTabRepeat(
        detable,
        this.contract_Goods,
        "barcode"
      );
      //向表格中导入最新的商品信息
      for (let i = 0; i < mtable.length; i++) {
        this.contract_Goods.push(mtable[i]);
      }
      //向表最上面导入库中有超市没有的商品
      for (let i = 0; i < newtab.length; i++) {
        this.contract_Goods.unshift(newtab[i]);
      }
      //向表最上面导入库中没有的商品
      for (let i = 0; i < newnewtab.length; i++) {
        this.contract_Goods.unshift(newnewtab[i]);
      }
      this.$refs.excel.hiddleBox();
      this.assignmentRowKey();
    },
    //给rowKey赋值
    assignmentRowKey() {
      this.contract_Goods.forEach((item, index, arr) => {
        item.rowKey = index;
      });
    },
    // 覆盖并导入数据
    CoverTableData(val) {
      this.contract_Goods = val;
      this.assignmentRowKey();
      this.$refs.excel.hiddleBox();
      this.rowkey = -1;
    },
    addLine() {
      this.contract_Goods.unshift({
        rowKey: "",
        barcode: "",
        item_name: "",
        price: "",
        advise_price: ""
      });
      this.assignmentRowKey();
    },
    async submitCollection(e) {
      if(e==2){
        // this.submitGoods();
        this.$emit("changeContract","",async res=>{
          console.log("修改合同返回---------：",res);
        })
        return;
      }
      this.$emit("subContract", "", async res => {
        this.contract_no = res;
        if(this.contract_Goods.length>0){
          this.submitGoods();
        }
        /* if (e == 1) {

         const data_info = {
            access_token: localStorage.getItem("access_token"),
            contract_no: res,
            mch_no:localStorage.getItem("mch_id"),
            items: this.contract_Goods
          };
          const result = await GenerateContractItems(data_info);
          console.log("添加商品", result);
        }*/
      });
    },
    async submitGoods(){
      const data_info = {
            access_token: localStorage.getItem("access_token"),
            contract_no: this.contract_no,
            mch_no:localStorage.getItem("mch_id"),
            items: this.contract_Goods
          };
          const result = await GenerateContractItems(data_info);
          console.log("添加商品", result);
    }
  }
};
</script>

<style scoped lang="less">
.btn-group {
  display: flex;
  text-align: right;
  height: auto;
  background-color: white;
  margin-bottom: 10px;
  justify-content: space-between;
  .top-btn-danju {
    height: auto;
    width: auto;
    padding-left: 10px;
    border-left: 5px solid #ffbb72;
    font-size: 14px;
    line-height: 2;
  }
}
.empty-data {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  width: 100%;
  color: #666;
  font-size: 16px;
  border: 1px solid #eee;
  border-top: 0;
}
</style>
